<div class="filterAnlage">
  <form>
    <mat-form-field appearance="fill">
      <mat-label>{{placeholder}}</mat-label>
      <input matInput type="text" [placeholder]="placeholder" [formControl]="filterCtl" [matAutocomplete]="auto"
        #trigger="matAutocompleteTrigger">
        <button matSuffix mat-icon-button
          (click)="$event.stopPropagation(); filterCtl.setValue(''); trigger.openPanel()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="OnValueChange($event)">
          @for (option of filteredOptions | async; track option) {
            <mat-option [value]="option">
              {{option}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </div>